import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const ActivityDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'activity',
        routeParamKey: 'activityId',
        pageTitle: 'Activity Details',
        backRoute: '/activities',
        backLabel: 'Back to Activities',
        tabIdPrefix: 'activity',
        tabsAriaLabel: 'activity detail tabs',
        missingIdMessage: 'No activity ID provided in the URL.',
        noDataMessage: 'No activity data available. The activity might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default ActivityDetailPage;